import * as React from 'react';

import styles from './GhostTile.module.scss';

const GhostTile = () => (
  <div className={styles.container} data-testid="ghost-tile">
    <div className={styles.bottom} data-testid="ghost-tile-bottom" />
  </div>
);

export default React.memo(GhostTile);
